export default __webpack_public_path__ + "static/media/balvinder-story.82cdda51.png";